export function dateMask(value) {
  let formattedValue = value.replace(/\D/g, '').slice(0, 8);

  if (formattedValue.length >= 5) {
    formattedValue = `${formattedValue.slice(0, 2)}/${formattedValue.slice(2, 4)}/${formattedValue.slice(4)}`;
  } else if (formattedValue.length >= 3) {
    formattedValue = `${formattedValue.slice(0, 2)}/${formattedValue.slice(2)}`;
  }

  return formattedValue;
}